export default "__VITE_ASSET__Dof$sUFF__"